var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellNotification = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 14.667 18.333",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.917 5.5a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5M7.333.458q.296.001.55.114c-.35.648-.55 1.39-.55 2.178 0 .481.074.945.212 1.38a4 4 0 0 0-.212-.005c-2.282 0-3.666 1.852-3.666 4.125v5.5H11v-5.5q0-.534-.1-1.03a4.6 4.6 0 0 0 1.869.034 8 8 0 0 1 .064.996v4.583l1.834 1.834v.916H0v-.916l1.833-1.834V8.25c0-2.823 1.504-5.17 4.125-5.793v-.624c0-.76.614-1.375 1.375-1.375m0 17.875A1.84 1.84 0 0 0 9.167 16.5H5.5c0 1.008.825 1.833 1.833 1.833",
    clipRule: "evenodd"
  })));
};
export default SvgBellNotification;